var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    [
      _c(
        "b-form-group",
        { attrs: { label: "Type of payment plan" } },
        [
          _c("b-form-select", {
            attrs: {
              options: _vm.planTypeOptions,
              state: _vm.fieldValid("type"),
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.plan.type,
              callback: function ($$v) {
                _vm.$set(_vm.plan, "type", $$v)
              },
              expression: "plan.type",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plan.type === "add-on"
        ? _c(
            "b-form-group",
            { attrs: { label: "Which hubs" } },
            [
              _c("b-form-checkbox-group", {
                attrs: {
                  options: _vm.planHubAddonOptions,
                  stacked: "",
                  disabled: _vm.disabled,
                },
                model: {
                  value: _vm.plan.hub_addons,
                  callback: function ($$v) {
                    _vm.$set(_vm.plan, "hub_addons", $$v)
                  },
                  expression: "plan.hub_addons",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("hub_addons") } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.validation.hub_addons) + "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Pricing plan name" } },
        [
          _c("b-form-input", {
            attrs: {
              state: _vm.fieldValid("name"),
              autocomplete: "off",
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.plan.name,
              callback: function ($$v) {
                _vm.$set(_vm.plan, "name", $$v)
              },
              expression: "plan.name",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.fieldValid("name") } },
            [_vm._v("\n      " + _vm._s(_vm.validation.name) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Pricing plan for" } },
        [
          _c("b-form-select", {
            attrs: {
              options: _vm.planCompanyTypeOptions,
              state: _vm.fieldValid("company_type"),
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.plan.company_type,
              callback: function ($$v) {
                _vm.$set(_vm.plan, "company_type", $$v)
              },
              expression: "plan.company_type",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.fieldValid("company_type") } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.validation.company_type) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Pricing plan rate" } },
        [
          _c("b-form-select", {
            attrs: {
              options: _vm.planRateOptions,
              state: _vm.fieldValid("rate"),
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.plan.rate,
              callback: function ($$v) {
                _vm.$set(_vm.plan, "rate", $$v)
              },
              expression: "plan.rate",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.fieldValid("rate") } },
            [_vm._v("\n      " + _vm._s(_vm.validation.rate) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plan.rate === "paid"
        ? _c(
            "b-form-group",
            { attrs: { label: "Pricing plan rate amount" } },
            [
              _c(
                "b-input-group",
                { attrs: { prepend: "$" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "number",
                      min: "0",
                      state: _vm.fieldValid("amount"),
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.plan.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.plan, "amount", $$v)
                      },
                      expression: "plan.amount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("amount") } },
                [_vm._v("\n      " + _vm._s(_vm.validation.amount) + "\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.plan.type === "membership"
        ? _c(
            "b-form-group",
            { attrs: { label: "Ability to add free access to certain hubs" } },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { disabled: _vm.disabled },
                  model: {
                    value: _vm.plan.is_hub_access,
                    callback: function ($$v) {
                      _vm.$set(_vm.plan, "is_hub_access", $$v)
                    },
                    expression: "plan.is_hub_access",
                  },
                },
                [_vm._v("\n      Yes\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.plan.type === "membership" && _vm.plan.is_hub_access
        ? _c(
            "b-form-group",
            { attrs: { label: "Which hubs" } },
            [
              _c("b-form-checkbox-group", {
                attrs: {
                  options: _vm.planHubAddonOptions,
                  stacked: "",
                  disabled: _vm.disabled,
                },
                model: {
                  value: _vm.plan.hub_addons,
                  callback: function ($$v) {
                    _vm.$set(_vm.plan, "hub_addons", $$v)
                  },
                  expression: "plan.hub_addons",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("hub_addons") } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.validation.hub_addons) + "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Display this plan in App" } },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { disabled: _vm.disabled },
              model: {
                value: _vm.plan.is_public,
                callback: function ($$v) {
                  _vm.$set(_vm.plan, "is_public", $$v)
                },
                expression: "plan.is_public",
              },
            },
            [_vm._v("\n      Yes\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plan.rate === "paid"
        ? [
            _c(
              "b-form-group",
              { attrs: { label: "Different rates by user type" } },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.plan.is_rates_by_user,
                      callback: function ($$v) {
                        _vm.$set(_vm.plan, "is_rates_by_user", $$v)
                      },
                      expression: "plan.is_rates_by_user",
                    },
                  },
                  [_vm._v("\n        Yes\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.plan.is_rates_by_user
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "15px",
                      background: "#f6f8fb",
                      "margin-bottom": "15px",
                    },
                  },
                  [
                    _vm._l(_vm.plan.rates_by_user, function (user, key) {
                      return _c(
                        "div",
                        { key: key },
                        [
                          _c(
                            "b-row",
                            [
                              !_vm.disabled
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticStyle: {
                                        "align-self": "flex-end",
                                        "padding-left": "15px",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticStyle: { height: "36px" },
                                          attrs: { variant: "danger" },
                                          on: {
                                            click: () =>
                                              _vm.removeUserRate(key),
                                          },
                                        },
                                        [_c("b-icon-x")],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "User type" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.userTypeOptions,
                                          state: _vm.fieldValid(
                                            `rates_by_user.${key}.type`
                                          ),
                                          disabled: _vm.disabled,
                                        },
                                        model: {
                                          value: user.type,
                                          callback: function ($$v) {
                                            _vm.$set(user, "type", $$v)
                                          },
                                          expression: "user.type",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.fieldValid(
                                              `rates_by_user.${key}.type`
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.validation[
                                                  `rates_by_user.${key}.type`
                                                ]
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Amount" } },
                                    [
                                      _c(
                                        "b-input-group",
                                        { attrs: { prepend: "$" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              state: _vm.fieldValid(
                                                `rates_by_user.${key}.amount`
                                              ),
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: user.amount,
                                              callback: function ($$v) {
                                                _vm.$set(user, "amount", $$v)
                                              },
                                              expression: "user.amount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.fieldValid(
                                              `rates_by_user.${key}.amount`
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.validation[
                                                  `rates_by_user.${key}.amount`
                                                ]
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    !_vm.disabled
                      ? _c(
                          "b-btn",
                          {
                            attrs: { type: "button", variant: "secondary" },
                            on: { click: _vm.addUserRate },
                          },
                          [_vm._v("\n        Add user rate\n      ")]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Different rates by limits" } },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.plan.is_rates_by_limit,
                      callback: function ($$v) {
                        _vm.$set(_vm.plan, "is_rates_by_limit", $$v)
                      },
                      expression: "plan.is_rates_by_limit",
                    },
                  },
                  [_vm._v("\n        Yes\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.plan.is_rates_by_limit
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "15px",
                      background: "#f6f8fb",
                      "margin-bottom": "15px",
                    },
                  },
                  [
                    _vm._l(_vm.plan.rates_by_limit, function (limit, key) {
                      return _c(
                        "div",
                        { key: key },
                        [
                          _c(
                            "b-row",
                            [
                              !_vm.disabled
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticStyle: {
                                        "align-self": "flex-end",
                                        "padding-left": "15px",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticStyle: { height: "36px" },
                                          attrs: { variant: "danger" },
                                          on: {
                                            click: () =>
                                              _vm.removeLimitRate(key),
                                          },
                                        },
                                        [_c("b-icon-x")],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Limit type" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.limitTypeOptions,
                                          disabled: _vm.disabled,
                                        },
                                        model: {
                                          value: limit.type,
                                          callback: function ($$v) {
                                            _vm.$set(limit, "type", $$v)
                                          },
                                          expression: "limit.type",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "From" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          state: _vm.fieldValid(
                                            `rates_by_limit.${key}.from`
                                          ),
                                          disabled: _vm.disabled,
                                        },
                                        model: {
                                          value: limit.from,
                                          callback: function ($$v) {
                                            _vm.$set(limit, "from", $$v)
                                          },
                                          expression: "limit.from",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.fieldValid(
                                              `rates_by_limit.${key}.from`
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.validation[
                                                  `rates_by_limit.${key}.from`
                                                ]
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "To" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          state: _vm.fieldValid(
                                            `rates_by_limit.${key}.to`
                                          ),
                                          disabled: _vm.disabled,
                                        },
                                        model: {
                                          value: limit.to,
                                          callback: function ($$v) {
                                            _vm.$set(limit, "to", $$v)
                                          },
                                          expression: "limit.to",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.fieldValid(
                                              `rates_by_limit.${key}.to`
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.validation[
                                                  `rates_by_limit.${key}.to`
                                                ]
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Amount" } },
                                    [
                                      _c(
                                        "b-input-group",
                                        { attrs: { prepend: "$" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              state: _vm.fieldValid(
                                                `rates_by_limit.${key}.amount`
                                              ),
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: limit.amount,
                                              callback: function ($$v) {
                                                _vm.$set(limit, "amount", $$v)
                                              },
                                              expression: "limit.amount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.fieldValid(
                                              `rates_by_limit.${key}.amount`
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.validation[
                                                  `rates_by_limit.${key}.amount`
                                                ]
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    !_vm.disabled
                      ? _c(
                          "b-btn",
                          {
                            attrs: { type: "button", variant: "secondary" },
                            on: { click: _vm.addLimitRate },
                          },
                          [_vm._v("\n        Add limit rate\n      ")]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.plan.type === "membership"
        ? [
            _c(
              "b-form-group",
              { attrs: { label: "Additional charges" } },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: {
                      checked: !_vm.plan.is_additional_charges,
                      disabled: _vm.disabled,
                    },
                    on: {
                      input: (val) => (_vm.plan.is_additional_charges = !val),
                    },
                  },
                  [_vm._v("\n        No additional charges\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.plan.is_additional_charges
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "15px",
                      background: "#f6f8fb",
                      "margin-bottom": "15px",
                    },
                  },
                  _vm._l(_vm.additionalChargeTypes, function (charge, key) {
                    return _c(
                      "b-row",
                      { key: key },
                      [
                        _c(
                          "b-col",
                          [
                            _c("b-form-group", { attrs: { label: "Type" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(charge.text) +
                                  "\n          "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Rate" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.additionalChargeRateOptions,
                                    state: _vm.fieldValid(
                                      `additional_charges.${charge.value}.rate`
                                    ),
                                    disabled: _vm.disabled,
                                  },
                                  model: {
                                    value:
                                      _vm.plan.additional_charges[charge.value]
                                        .rate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.plan.additional_charges[
                                          charge.value
                                        ],
                                        "rate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "plan.additional_charges[charge.value].rate",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-form-invalid-feedback",
                                  {
                                    attrs: {
                                      state: _vm.fieldValid(
                                        `additional_charges.${charge.value}.rate`
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.validation[
                                            `additional_charges.${charge.value}.rate`
                                          ]
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Amount" } },
                              [
                                _c(
                                  "b-input-group",
                                  {
                                    attrs: {
                                      prepend:
                                        _vm.plan.additional_charges[
                                          charge.value
                                        ].rate === "fixed"
                                          ? "$"
                                          : null,
                                      append:
                                        _vm.plan.additional_charges[
                                          charge.value
                                        ].rate === "%"
                                          ? "%"
                                          : null,
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        state: _vm.fieldValid(
                                          `additional_charges.${charge.value}.amount`
                                        ),
                                        disabled: _vm.disabled,
                                      },
                                      model: {
                                        value:
                                          _vm.plan.additional_charges[
                                            charge.value
                                          ].amount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.plan.additional_charges[
                                              charge.value
                                            ],
                                            "amount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "plan.additional_charges[charge.value].amount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-invalid-feedback",
                                  {
                                    attrs: {
                                      state: _vm.fieldValid(
                                        `additional_charges.${charge.value}.amount`
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.validation[
                                            `additional_charges.${charge.value}.amount`
                                          ]
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.plan.rate === "paid"
        ? [
            _c(
              "b-form-group",
              { attrs: { label: "Billing frequency" } },
              [
                _c("b-form-select", {
                  attrs: {
                    options: _vm.billingFrequencyOptions,
                    state: _vm.fieldValid("billing_frequency"),
                    disabled: _vm.disabled,
                  },
                  model: {
                    value: _vm.plan.billing_frequency,
                    callback: function ($$v) {
                      _vm.$set(_vm.plan, "billing_frequency", $$v)
                    },
                    expression: "plan.billing_frequency",
                  },
                }),
                _vm._v(" "),
                _c(
                  "b-form-invalid-feedback",
                  { attrs: { state: _vm.fieldValid("billing_recurrence") } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.validation.billing_frequency) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.plan.billing_frequency === "recurring"
              ? _c(
                  "b-form-group",
                  { attrs: { label: "Billing recurrence" } },
                  [
                    _c("b-form-select", {
                      attrs: {
                        options: _vm.billingRecurrenceOptions,
                        state: _vm.fieldValid("billing_recurrence"),
                        disabled: _vm.disabled,
                      },
                      model: {
                        value: _vm.plan.billing_recurrence,
                        callback: function ($$v) {
                          _vm.$set(_vm.plan, "billing_recurrence", $$v)
                        },
                        expression: "plan.billing_recurrence",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-form-invalid-feedback",
                      {
                        attrs: { state: _vm.fieldValid("billing_recurrence") },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.validation.billing_recurrence) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Free trial" } },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.plan.is_free_trial,
                      callback: function ($$v) {
                        _vm.$set(_vm.plan, "is_free_trial", $$v)
                      },
                      expression: "plan.is_free_trial",
                    },
                  },
                  [_vm._v("\n        Yes\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.plan.is_free_trial
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "15px",
                      background: "#f6f8fb",
                      "margin-bottom": "15px",
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Length" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "number",
                                    state: _vm.fieldValid("free_trial_length"),
                                    disabled: _vm.disabled,
                                  },
                                  model: {
                                    value: _vm.plan.free_trial_length,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.plan,
                                        "free_trial_length",
                                        $$v
                                      )
                                    },
                                    expression: "plan.free_trial_length",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-form-invalid-feedback",
                                  {
                                    attrs: {
                                      state:
                                        _vm.fieldValid("free_trial_length"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.validation.free_trial_length
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: "Period" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.freeTrialPeriodOptions,
                                    state: _vm.fieldValid("free_trial_period"),
                                    disabled: _vm.disabled,
                                  },
                                  model: {
                                    value: _vm.plan.free_trial_period,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.plan,
                                        "free_trial_period",
                                        $$v
                                      )
                                    },
                                    expression: "plan.free_trial_period",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-form-invalid-feedback",
                                  {
                                    attrs: {
                                      state:
                                        _vm.fieldValid("free_trial_period"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.validation.free_trial_period
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.plan.type === "membership"
        ? [
            _c(
              "b-form-group",
              { attrs: { label: "Set limit of active licenses" } },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.plan.is_limit_licenses,
                      callback: function ($$v) {
                        _vm.$set(_vm.plan, "is_limit_licenses", $$v)
                      },
                      expression: "plan.is_limit_licenses",
                    },
                  },
                  [_vm._v("\n        Yes\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.plan.is_limit_licenses
              ? [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Number of active licenses included" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "number",
                          min: "0",
                          state: _vm.fieldValid("licenses_limit"),
                          disabled: _vm.disabled,
                        },
                        model: {
                          value: _vm.plan.licenses_limit,
                          callback: function ($$v) {
                            _vm.$set(_vm.plan, "licenses_limit", $$v)
                          },
                          expression: "plan.licenses_limit",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        { attrs: { state: _vm.fieldValid("licenses_limit") } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.validation.licenses_limit) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.plan.rate === "paid"
                    ? [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Allow additional licenses" } },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: { disabled: _vm.disabled },
                                model: {
                                  value: _vm.plan.allow_extra_licenses,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.plan,
                                      "allow_extra_licenses",
                                      $$v
                                    )
                                  },
                                  expression: "plan.allow_extra_licenses",
                                },
                              },
                              [_vm._v("\n            Yes\n          ")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.plan.allow_extra_licenses
                          ? _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Price per each additional license",
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  { attrs: { prepend: "$" } },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        state: _vm.fieldValid(
                                          "extra_license_price"
                                        ),
                                        disabled: _vm.disabled,
                                      },
                                      model: {
                                        value: _vm.plan.extra_license_price,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.plan,
                                            "extra_license_price",
                                            $$v
                                          )
                                        },
                                        expression: "plan.extra_license_price",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-invalid-feedback",
                                  {
                                    attrs: {
                                      state: _vm.fieldValid(
                                        "extra_license_price"
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.validation.extra_license_price
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }